import React from 'react'

export const Separator = () => {
  return (
    <div className='separator'>
        <span></span>
        <span></span>
    </div>
  )
}
